import { useEffect } from 'react';
import { trackAccountAdded } from '@/shared/analytics/accountAdded';
import { Account } from '../../types';

export function useTrackAccountsAdded(accounts: Account[]) {
  useEffect(() => {
    for (const account of accounts) {
      trackAccountAdded({ accountId: account.id, destinationCountry: account.to_country_code });
    }
  }, [accounts]);
}
